<h2>{{'CLIENT.documents.download_file' | translate}}!</h2>
<mat-spinner *ngIf="isLoading" diameter="30"></mat-spinner>
<div *ngIf="!isLoading" class="col-3">
  <p>{{appDocument?.name}} {{'CLIENT.documents.generated_on' | translate}} {{appDocument?.created_at}}</p>
  <app-spinner-btn class="w-25" [loading]="isSubmitting" [name]="'CASES.single.download' | translate"
                   (click)="downloadDocument()"></app-spinner-btn>
</div>

